import { c as _c } from "react/compiler-runtime";
import { Modal, PrimaryButton, SecondaryButton, toast } from '@systemeio/ui';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { WebsiteErrorsInterface } from '../types/website-interface';
import { SectionErrorsPathList } from './section-errors-path-list';
interface ActivateWebsiteModalProps {
  opened: boolean;
  errors: WebsiteErrorsInterface;
  onChangeStatus: () => Promise<void>;
  onClose: () => void;
  afterLeave: () => void;
}
export const ActivateWebsiteModal = t0 => {
  const $ = _c(42);
  const {
    opened,
    onChangeStatus,
    errors,
    onClose,
    afterLeave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== onChangeStatus || $[1] !== onClose || $[2] !== t) {
    t1 = async () => {
      ;
      try {
        setIsFetching(true);
        await onChangeStatus();
        toast.success(t("dashboard.actions.activated", {
          module: t("dashboard.website.title").toLowerCase(),
          activated: t("dashboard.actions.activated_caption").toLowerCase()
        }));
        setIsFetching(false);
        onClose();
      } catch (t2) {
        setIsFetching(false);
      }
    };
    $[0] = onChangeStatus;
    $[1] = onClose;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handelChangeStatus = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("confirmation_modal.default_title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("dashboard.actions.activate_confirmation", {
      activate: t("global.activate").toLowerCase(),
      module: t("dashboard.website.title").toLowerCase()
    });
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="flex justify-center"><p className="text-text-primary text-base">{t3}</p></div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== errors.path) {
    t5 = errors.path && <SectionErrorsPathList error={errors.path.split("\n")} />;
    $[10] = errors.path;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onClose) {
    t6 = e_0 => {
      e_0.preventDefault();
      onClose();
    };
    $[12] = onClose;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("confirmation_modal.cancel");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isFetching || $[17] !== t6 || $[18] !== t7) {
    t8 = <SecondaryButton width="large" className="w-full" onClick={t6} disabled={isFetching}>{t7}</SecondaryButton>;
    $[16] = isFetching;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== handelChangeStatus) {
    t9 = async e_1 => {
      e_1.preventDefault();
      await handelChangeStatus();
    };
    $[20] = handelChangeStatus;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("confirmation_modal.confirm");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== isFetching || $[25] !== t10 || $[26] !== t9) {
    t11 = <PrimaryButton isFetching={isFetching} width="large" className="w-full" onClick={t9} type="submit">{t10}</PrimaryButton>;
    $[24] = isFetching;
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t8) {
    t12 = <div className="flex justify-center gap-4">{t8}{t11}</div>;
    $[28] = t11;
    $[29] = t8;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t4 || $[33] !== t5) {
    t13 = <form className="flex flex-col gap-6">{t4}{t5}{t12}</form>;
    $[31] = t12;
    $[32] = t4;
    $[33] = t5;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== afterLeave || $[36] !== isFetching || $[37] !== onClose || $[38] !== opened || $[39] !== t13 || $[40] !== t2) {
    t14 = <><Modal opened={opened} onClose={onClose} title={t2} isFetching={isFetching} isCentered={true} afterLeave={afterLeave}>{t13}</Modal></>;
    $[35] = afterLeave;
    $[36] = isFetching;
    $[37] = onClose;
    $[38] = opened;
    $[39] = t13;
    $[40] = t2;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
};